/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FotaService {
  /**
   * 部署记录 - 列表查询
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaTaskList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/task/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 创建部署任务
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaTaskDeploy(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/task/deploy',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署任务删除/批量删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaTaskDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/task/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 重新部署
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployStart(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/start',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 详情
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployDetail(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/detail',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 详情 - 实时日志 (SSE)
   * @param deployNodeId 部署id
   * @param contentType
   * @returns any 成功
   * @throws ApiError
   */
  static getFotaDeployLogRealtime(deployNodeId, contentType) {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/fota/deploy/log/realtime',
      headers: {
        'Content-Type': contentType
      },
      query: {
        'deployNodeId': deployNodeId
      }
    });
  }
  /**
   * 上传固件包
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareActionsUpload(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/actions/upload',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 新增固件信息
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareActionsAdd(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/actions/add',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 查询固件信息列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareActionsQuery(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/actions/query',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 删除固件信息
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareActionsDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/actions/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署 - 查询部署节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareNode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/node',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 查询已部署节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaFirmwareDeploy(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/firmware/deploy',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 编辑
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployEdit(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/edit',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 部署记录 - 节点总数 - 详情 - 实时日志SSE channel
   * @returns any 成功
   * @throws ApiError
   */
  static postFotaDeployLogChannel() {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/fota/deploy/log/channel'
    });
  }
}